export function makeQuizQuestionInputKey(questionId: number) {
  return `question-${questionId}`;
}

export default makeQuizQuestionInputKey;
